
import React from "react";

export function ImagemLogo(props) {
    return (
      <>
        <img
          className={"hidden dark:block"}
          src={'/logo-gradiente.png'}
          width='220px'
          alt='log-direto-alt'
          height='360px'
        />
        <img
          className="flex dark:hidden"
          src={'/logo-azulescura.png'}
          width='220px'
          alt='log-direto'
          height='360px'
        />
      </>
    )
}

export function ImagemLogoReverse(props) {
  return (
    <>
      <img
        className="flex dark:hidden"
        src={'/logo-azulescura.png'}
        width='220'
        alt='log-direto-alt'
        height='360'
      />
      <img
        className="hidden dark:flex"
        src={'/logo-gradiente.png'}
        width='220'
        alt='log-direto'
        height='360'
      />
    </>
  )
}

export function ImagemCapa(props) {
  return (
    <>
      <img
        className={"hidden dark:block"}
        src={'/Cadastro_Plataforma_Rebrand.png'}
        // width='220px'
        // height='360px'
        alt='capa-direto-alt'
      />
      <img
        className="block dark:hidden"
        src={'/Cadastro_Plataforma_Rebrand.png'}
        // width='220px'
        // height='360px'
        alt='capa-direto'
      />
    </>
  )
}